import React, { useState } from 'react';
import { Pencil } from 'lucide-react';
import { kindLabel, usesPermissionFlow } from './permission';
import { actsAsOwner } from './ownership';
import EditPermissionModal from './EditPermissionModal';

const PermissionPanel = ({ task, embedded = false }) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  if (!usesPermissionFlow(task)) return null;

  // Only the owner (or the company's builder acting as owner) may change
  // these fields; the API enforces it, this just hides the button.
  const isOwner = actsAsOwner(task);

  const formatDate = (value) => {
    if (!value) return '---';
    return new Date(value).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const editButton = isOwner && (
    <button
      type="button"
      onClick={() => setIsEditOpen(true)}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#E5EAF1] bg-white px-3 py-1.5 text-sm font-medium text-[#346C75] shadow-sm transition-colors hover:bg-[#F7FAFB]"
    >
      <Pencil size={14} strokeWidth={2} />
      Edit
    </button>
  );

  return (
    <div className={embedded ? 'space-y-5' : 'bg-white rounded-lg shadow p-6 space-y-5'}>
      {(!embedded || editButton) && (
        <div className="flex items-center justify-between gap-3">
          {!embedded ? (
            <h2 className="text-lg font-semibold text-gray-800">{kindLabel(task.kind)}</h2>
          ) : (
            <span />
          )}
          {editButton}
        </div>
      )}
      <div className={`grid grid-cols-1 ${embedded ? '' : 'md:grid-cols-3'} gap-4 text-sm text-gray-700`}>
        <div>
          <div className="text-gray-500">Authority</div>
          <div>{task.authority || '---'}</div>
        </div>
        <div>
          <div className="text-gray-500">Application no.</div>
          <div>{task.applicationNumber || '---'}</div>
        </div>
        <div>
          <div className="text-gray-500">Start date</div>
          <div>{formatDate(task.permissionStartDate)}</div>
        </div>
        <div>
          <div className="text-gray-500">End date</div>
          <div>{formatDate(task.permissionEndDate)}</div>
        </div>
      </div>
      {isEditOpen && (
        <EditPermissionModal task={task} onClose={() => setIsEditOpen(false)} />
      )}
    </div>
  );
};

export default PermissionPanel;
